import { useState } from 'react';
import MobiscrollCalendar from '../../components/Calendar/MobiscrollCalendar';
import { MbscCalendarEvent } from '@mobiscroll/react';
import { EventInfo } from '../../types/mobiScroll';
import WorkPackageDetailsDialog from './WorkPackageDetailsDialog';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';

const ShortTermHangarPlanTab = ({ data, hangars, onRefresh }: { data: EventInfo[]; hangars: string[] ;  onRefresh: () => void }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState<MbscCalendarEvent>();

    const me = useSelector((state: RootState) => state.user.me);
    
    const onEventClicked = (event: MbscCalendarEvent) => {
        setSelectedEvent(event.event);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        onRefresh();
        setSelectedEvent(undefined); // Reset selectedEvent on close
    };
   
    return (
        <div className="flex flex-1 flex-col min-h-0 [&_.mbsc-schedule-event-range.mbsc-ios]:!hidden">
            <div className="flex flex-1 flex-col min-h-0">
                <MobiscrollCalendar
                    calendarTasks={data}
                    resources={hangars}
                    onEventClick={onEventClicked}
                    isShortTermView={true}
                />
            </div>
            {dialogOpen && selectedEvent && (
                <WorkPackageDetailsDialog
                    location="HANGAR"
                    dialogOpen={dialogOpen}
                    onClose={handleDialogClose}
                    selectedEvent={selectedEvent}
                    isAdmin={me.user_clearence_groups.includes("Hangar Plan Edit")}
                />
            )}
        </div>
    );
}
export default ShortTermHangarPlanTab;